import { CONFIG } from '../config.js';
import { MathUtils } from '../utils/MathUtils.js';

/**
 * Pointer Lock API + mouse look.
 */
export class PointerLockInput {
  /**
   * @param {{
   *   canvas: HTMLCanvasElement;
   *   sensitivity?: number;
   *   pitchMin?: number;
   *   pitchMax?: number;
   * }} options
   */
  constructor({
    canvas,
    sensitivity = CONFIG.player.mouseSensitivity,
    pitchMin = CONFIG.player.pitchMin,
    pitchMax = CONFIG.player.pitchMax,
  }) {
    this.canvas = canvas;
    this.sensitivity = sensitivity;
    this.pitchMin = pitchMin;
    this.pitchMax = pitchMax;

    this.yaw = 0;
    this.pitch = 0;
    this.isLocked = false;

    /** @type {((locked: boolean) => void) | null} */
    this.onLockChange = null;
    /** @type {((yaw: number, pitch: number) => void) | null} */
    this.onLookSync = null;

    this._onClick = () => this.requestLock();
    this._onPointerLockChange = () => {
      this.isLocked = document.pointerLockElement === this.canvas;
      this.canvas.classList.toggle('is-pointer-locked', this.isLocked);
      if (this.isLocked && this.onLookSync) {
        this.onLookSync(this.yaw, this.pitch);
      }
      if (this.onLockChange) this.onLockChange(this.isLocked);
    };
    this._onMouseMove = (event) => {
      if (document.pointerLockElement !== this.canvas) return;
      if (event.movementX === 0 && event.movementY === 0) return;

      this.yaw = MathUtils.wrapAngle(
        this.yaw - event.movementX * this.sensitivity,
      );
      this.pitch = MathUtils.clamp(
        this.pitch - event.movementY * this.sensitivity,
        this.pitchMin,
        this.pitchMax,
      );
    };
    this._onContextMenu = (event) => event.preventDefault();
  }

  attach() {
    this.canvas.addEventListener('click', this._onClick);
    this.canvas.addEventListener('contextmenu', this._onContextMenu);
    document.addEventListener('pointerlockchange', this._onPointerLockChange);
    document.addEventListener('mousemove', this._onMouseMove);
  }

  detach() {
    this.exitLock();
    this.canvas.removeEventListener('click', this._onClick);
    this.canvas.removeEventListener('contextmenu', this._onContextMenu);
    document.removeEventListener('pointerlockchange', this._onPointerLockChange);
    document.removeEventListener('mousemove', this._onMouseMove);
  }

  requestLock() {
    if (document.pointerLockElement === this.canvas) return;
    this.canvas.requestPointerLock();
  }

  exitLock() {
    if (document.pointerLockElement === this.canvas) {
      document.exitPointerLock();
    }
  }
}
